import React from 'react';
import { useIntl } from "react-intl";

interface CheckboxFieldProps {
    isChecked: boolean;
    setIsChecked: (value: boolean) => void;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({ isChecked, setIsChecked }) => {
    const { formatMessage } = useIntl();

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked);
    };

    return (
        <div className='padding-top-30'>
            <label className='d-flex gap-10px align-items-center'>
                <div className='font-size-16px'>
                    {formatMessage({ id: 'variations' })}
                </div>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                />
                <div>
                    {formatMessage({ id: 'has_variation_label' })}
                </div>
            </label>
        </div>
    );
};

export default CheckboxField;
